var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAttention(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 110,
    rx: 55,
    fill: "#FEBD35",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.75 66.9582C56.75 67.9247 55.9665 68.7082 55 68.7082C54.0335 68.7082 53.25 67.9247 53.25 66.9582C53.25 65.9917 54.0335 65.2082 55 65.2082C55.9665 65.2082 56.75 65.9917 56.75 66.9582Z",
    fill: "#FEBD35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.4325 33.7082C51.3514 28.6526 58.6484 28.6526 61.5673 33.7082L81.7745 68.7082C84.6933 73.7637 81.0448 80.0832 75.2072 80.0832H34.7926C28.955 80.0832 25.3065 73.7637 28.2253 68.7082L48.4325 33.7082ZM58.5362 35.4582C56.9645 32.7359 53.0353 32.7359 51.4636 35.4582L31.2564 70.4582C29.6847 73.1804 31.6493 76.5832 34.7926 76.5832H75.2072C78.3505 76.5832 80.3151 73.1804 78.7434 70.4582L58.5362 35.4582ZM55 43.0415C55.9665 43.0415 56.75 43.825 56.75 44.7915V60.8332C56.75 61.7997 55.9665 62.5832 55 62.5832C54.0335 62.5832 53.25 61.7997 53.25 60.8332V44.7915C53.25 43.825 54.0335 43.0415 55 43.0415Z",
    fill: "#FEBD35"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttention);
export default __webpack_public_path__ + "static/media/attention.d5460a96746b406869331390922221bd.svg";
export { ForwardRef as ReactComponent };